<template>
  <!-- VERSÃO DESKTOP -->
  <div class="login flex row justify-end" v-if="!isMobile" style="height: 100vh; width: 100vw">
    <div class="img col-6 bg-verde">
      <q-img
        src="../../../assets/bg_login_GE.png"
        height="100vh"
      />
    </div>
    <div class="form col-6 flex justify-center bg-verde">
      <div class="q-mt-md">
        <div class="titles">
          <div class="logo q-mt-xl">
            <q-img
              class="q-my-xl"
              src="../../../assets/logo_gestaosistema.png"
              width="400px"
            />
          </div>
          <!-- <div class="text-center text-white text-bold text-h2" style="font-family: 'Gemunu Libre'">
            Gestão Esportes
          </div> -->
          <!-- <q-separator spaced color="white" /> -->
          <div class="text-left text-bold text-h6 text-white">
            Informar novas senhas de acesso:
          </div>
        </div>
        <form>
          <div class="inputs col">
            <q-input
              outlined
              class="q-my-md"
              color="verde"
              bg-color="white"
              v-model="passOne"
              :type="isPwdOne ? 'password' : 'text'"
              label="Digitar nova senha..."
            >
              <template v-slot:append>
                <q-icon
                  :name="isPwdOne ? 'visibility' : 'visibility_off'"
                  @click="isPwdOne = !isPwdOne"
                />
              </template>
            </q-input>
            <q-input
              outlined
              class="q-my-md"
              color="verde"
              bg-color="white"
              v-model="passTwo"
              :type="isPwdTwo ? 'password' : 'text'"
              label="Repita a nova senha..."
              @keypress.enter="onAccess"
            >
              <template v-slot:append>
                <q-icon
                  :name="isPwdTwo ? 'visibility' : 'visibility_off'"
                  @click="isPwdTwo = !isPwdTwo"
                />
              </template>
            </q-input>
          </div>
          <div class="btns row">
            <q-btn glossy class="full-width" outline color="white" label="Alterar Senha" @click="onResetPass" />
          </div>
        </form>
      </div>
    </div>
  </div>

  <!-- VERSÃO MOBILE -->
  <div class="login flex column justify-end" v-else style="height: 100vh; width: 100vw">
    <div class="img col-2 bg-verde">
      <div class="image" style="z-index: 1;">
        <q-img
          src="../../../assets/bg_login_GE.png"
          height="100vh"
        />
      </div>
    </div>
    <div class="form col-10 flex justify-center bg-verde">
      <div class="q-mt-xl q-pt-xl" style="z-index: 2;">
        <div class="bgColorFormMobile q-pa-md">
          <div class="title text-white text-bold text-h3 q-mb-md" style="font-family: 'Gemunu Libre'">
            <div class="row justify-center">
                <q-img
                  src="../../../assets/logo_gestaosistema.png"
                  height="auto"
                  width="300px"
                />
            </div>
          </div>
          <div class="inputs col" style="width: 80vw">
            <q-input
              outlined
              class="q-my-md"
              bg-color="white"
              color="verde"
              v-model="mail"
              type="email"
              label="E-Mail"
            />
            <q-input
              outlined
              class="q-my-md"
              color="verde"
              bg-color="white"
              v-model="pass"
              :type="isPwd ? 'password' : 'text'"
              label="Senha"
            >
              <template v-slot:append>
                <q-icon
                  :name="isPwd ? 'visibility' : 'visibility_off'"
                  @click="isPwd = !isPwd"
                />
              </template>
            </q-input>
          </div>
          <div class="btns row">
            <q-btn glossy class="full-width text-black" color="white" label="Acessar" @click="onAccess" />
            <!-- <q-btn class="col-6" flat color="white" label="Esqueci a senha" @click="onShowRemmenber" /> -->
          </div>
        </div>

        <q-btn
          no-caps
          flat
          class="tutor text-bold text-italic text-h6"
          text-color="white"
          label="Vídeos Tutoriais"
          @click="onTutor"
        />

        <div class="suporte">
          <q-avatar
            size="50px"
            font-size="40px"
            text-color="green"
            icon="fab fa-whatsapp"
            @click="onRedirectWhats"
          />
          <q-chip
            class="bg-green-3"
            icon="person"
            label="Posso te ajudar?"
            v-model="msgWhats"
            @click="onRedirectWhats"
            removable
            @remove="msgWhats = false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Dialog } from 'quasar';
import { supabase } from '../../../supabase';

export default {
  data() {
    return {
      passOne: '',
      passTwo: '',
      isPwdOne: true,
      isPwdTwo: true,
      nameEnterprise: null
    }
  },
  computed: {
    isMobile() {
      return (this.$q.screen.sm || this.$q.screen.xs);
    }
  },
  methods: {
    validationPass() {
      if(this.passOne !== this.passTwo) {
        Dialog.create({
          title: 'Gestão Esportes',
          message: 'Favor verificar senhas informadas. As senhas informadas não coincidem!'
        })

        return false;
      } else {
        return true;
      }
    },
    onResetPass() {
      // if(!this.validationPass)
      //   return null;

      
      supabase.auth.onAuthStateChange(async event => {
        console.log(event)
        if(event === 'PASSWORD_RECOVERY') {
          const { user, error } = await supabase
            .auth
            .api
            .updateUser({
              password: this.passOne
            })

          console.log(user);
          console.log(error);

          if(user) {
            Dialog.create({
              title: 'Gestão Esportes',
              message: 'Senha alterada com sucesso!'
            });

            this.$router.push('/');
          }

          if(error)
            Dialog.create({
              title: 'Gestão Esportes',
              message: `Erro ao alterar senha. ${error.message}`
            });
        }
      })
    }
  },
}
</script>

<style lang="scss" scoped>
  .bgColorFormMobile {
    background-color: rgba(13, 46, 29, 0.8);
    border-radius: 15px;
    box-shadow: 0px 0px 30px rgb(83, 144, 111)
  }

  .tutor {
    position: absolute;
    bottom: 0;
  }

  .newUser {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  .suporte {
    position: fixed;
    left: 10px;
    top: 5px;
  }

  @import url('https://fonts.googleapis.com/css2?family=Gemunu+Libre&display=swap');
</style>
